import React from 'react';
import { Modal, Button } from 'antd';
import { StyledPara } from './styled';

function VerifyModal({ openVerifyModel, setOpenVerifyModel, partnerName }) {
  const onConfirm = () => {
    setOpenVerifyModel(false);
  };

  const onCancel = () => {
    setOpenVerifyModel(false);
  };

  const footerButtons = [
    <Button key="discard" onClick={onCancel}>
      Cancel
    </Button>,
    <Button key="save" type="primary" onClick={onConfirm}>
      Confirm
    </Button>,
  ];

  return (
    <Modal
      title={`Confirm ${partnerName} Configuration`}
      width="550px"
      open={openVerifyModel}
      onCancel={onCancel}
      footer={footerButtons}
    >
      <StyledPara>
        <p>
          To validate the
          {` ${partnerName} `}
          configuration, a test incident has been sent to
          {` ${partnerName}`}. Click Confirm if you received the
          {` ${partnerName} `}
          incident notification. Otherwise, re-check the configuration details.
        </p>
      </StyledPara>
    </Modal>
  );
}

export default VerifyModal;
